import './record.css'
import React, {useContext, useEffect, useState} from "react";
import {useUserContext} from "../../../../providers/userProvider/user-context.tsx";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import useLoading from "../../../../providers/loadingContext/useLoading.ts";
import {VISITOR_LOGIN_LEADERBOARD_TIP} from "../../../../common/constants.ts";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";
import debounce from "lodash/debounce";
import {apiService} from "../../../../common/utils/http/api-service.ts";
import {IUserGame} from "../../../../common/utils/http/IResponse.ts";

type props = {
    isOpen: boolean,
}


// 记录页
const RecordPage: React.FC<props> = ({isOpen}) => {
    const {showLoading, hideLoading} = useLoading();
    const {user} = useUserContext();
    // leaderboard中的record
    const [gameRecord, setGameRecord] = useState<IUserGame>();
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);

    useEffect(() => {
        if (isOpen) {
            GAEvents.leaderboardPageShow('Record')
            getRecord();
        }
    }, [isOpen]);

    // 获取rank列表
    const getRecord = debounce(async () => {
        try {
            showLoading();
            const response = await apiService.getProfileGameData()
            if (response.code === 200) {
                setGameRecord(response.data);
            }
        } finally {
            hideLoading()
        }
    }, 100);

    return (
        <div className="leaderboard-record-page margin-left-right-auto margin-top-20"
             style={{backgroundImage: `url(${imgUrls.leaderboardRecordCardBgUrl})`}}>
            <div className="daily-record-title my-roboto-medium">Daily Record</div>
            <div className="record-item-container">
                {user?.loginType === 1 ? <div
                        className="font-size-14 my-roboto-medium margin-bottom-6 color-blue">{VISITOR_LOGIN_LEADERBOARD_TIP}</div> :
                    <div className="title-text my-roboto-medium">{gameRecord?.dailyHighestRank}</div>}
                <div className="description-text my-roboto-light color-grey">All-time highest ranking</div>
            </div>
            <div className="record-item-container">
                {/*<div className="title-text my-roboto-medium">{gameRecord?.dailyAverageTime}</div>*/}
                <div className="title-text my-roboto-medium">{gameRecord?.averageGuess ?? 0}</div>
                <div className="description-text my-roboto-light color-grey">Average attempts</div>
            </div>
            <div className="daily-record-title my-roboto-medium">Challenge Record</div>
            <div className="record-item-container">
                {user?.loginType === 1 ? <div
                        className="font-size-14 my-roboto-medium margin-bottom-6 color-blue">{VISITOR_LOGIN_LEADERBOARD_TIP}</div> :
                    <div className="title-text my-roboto-medium">{gameRecord?.aiChallengeHighestRank}</div>}
                <div className="description-text my-roboto-light color-grey">All-time highest ranking</div>
            </div>
            <div className="record-item-container">
                <div className="title-text my-roboto-medium">{gameRecord?.aiChallengeBestStreak ?? 0}</div>
                <div className="description-text my-roboto-light color-grey">Best streak</div>
            </div>
        </div>
    );
}

export default RecordPage;